/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RiskIDRequestBody,
  RiskIDRequestBody$Outbound,
  RiskIDRequestBody$outboundSchema,
} from "../components/riskidrequestbody.js";

export type RotateOrganizationRemoteSessionClientSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type RotateOrganizationRemoteSessionClientRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  riskIDRequestBody: RiskIDRequestBody;
};

/** @internal */
export type RotateOrganizationRemoteSessionClientSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const RotateOrganizationRemoteSessionClientSecurity$outboundSchema:
  z.ZodMiniType<
    RotateOrganizationRemoteSessionClientSecurity$Outbound,
    RotateOrganizationRemoteSessionClientSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
      apikeyHeaderGramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
      });
    }),
  );

export function rotateOrganizationRemoteSessionClientSecurityToJSON(
  rotateOrganizationRemoteSessionClientSecurity:
    RotateOrganizationRemoteSessionClientSecurity,
): string {
  return JSON.stringify(
    RotateOrganizationRemoteSessionClientSecurity$outboundSchema.parse(
      rotateOrganizationRemoteSessionClientSecurity,
    ),
  );
}

/** @internal */
export type RotateOrganizationRemoteSessionClientRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  RiskIDRequestBody: RiskIDRequestBody$Outbound;
};

/** @internal */
export const RotateOrganizationRemoteSessionClientRequest$outboundSchema:
  z.ZodMiniType<
    RotateOrganizationRemoteSessionClientRequest$Outbound,
    RotateOrganizationRemoteSessionClientRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
      riskIDRequestBody: RiskIDRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
        riskIDRequestBody: "RiskIDRequestBody",
      });
    }),
  );

export function rotateOrganizationRemoteSessionClientRequestToJSON(
  rotateOrganizationRemoteSessionClientRequest:
    RotateOrganizationRemoteSessionClientRequest,
): string {
  return JSON.stringify(
    RotateOrganizationRemoteSessionClientRequest$outboundSchema.parse(
      rotateOrganizationRemoteSessionClientRequest,
    ),
  );
}
